import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { WIDTH as SIDEBAR_WIDTH } from '../sidenav/sidenav.constants';
import { getScreenSize, SCREEN_HEIGHT, SCREEN_WIDTH } from '../tornado/utils/sizes';
import { makeDefaultStylingContext } from '../tornado/utils/style';

export const defaultContext = makeDefaultStylingContext();

export const LEFT_PADDING = {
  [HD]: 96,
  [FULL_HD]: 192,
};

export const TOP_PADDING = {
  [HD]: 160,
  [FULL_HD]: 240,
};

export const colors = {
  background: makeThemeColor(TERTIARY),
};

export const getContentPadding = (hasSideNav = true, screenSize = undefined) => {
  const screenDimension = screenSize || getScreenSize();

  return hasSideNav ? SIDEBAR_WIDTH[screenDimension] + LEFT_PADDING[screenDimension] : LEFT_PADDING[screenDimension];
};

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => ({
  Background: {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    color: colors.background[colorMode],
  },
  Grid: {
    x: getContentPadding(true, screenSize),
    y: TOP_PADDING[screenSize],
  },
});
